import { gql, useQuery } from '@apollo/client'
import { BrandInfo } from '@@partner:types:app'
import { SHORTCUT_REPING_AUTH } from '@@partner:graphql/shortcuts'

export interface CurrentBrandInfoResult {
  brandInfo: BrandInfo
}

export interface CurrentBrandInfoVariables {
  style?: string
}

export const GQL_QUERY_CURRENT_BRAND_INFO = gql`
  query {
    brandInfo: currentBrandInfo {
      id
      name
      slug
      logo_id
      logo {
        url
      }
      square_logo_id
      squareLogo {
        url
      }
      defaultShop {
        id
        name
        address
      }
      primaryColorHex
      primaryTextColorHex
      appStyleConfig
      brandFiles {
        key
        file_id
        name
        fileSize
        addedAt
        file {
          url
        }
      }

      assemblerConfig {
        alerts {
          title
          text
          restrictAccessToApp
          button {
            text
            action
            actionData
          }
        }
        inAppMessages {
          type
          text
        }
        minimalVersion
        positionCancelReasons {
          text
          canComment
          requireComment
        }
        orderCancelReasons {
          text
          canComment
          requireComment
        }
      }
    }
  }
`

export const useFetchBrandInfo = (variables?: CurrentBrandInfoVariables) => {
  return useQuery<CurrentBrandInfoResult, CurrentBrandInfoVariables>(
    GQL_QUERY_CURRENT_BRAND_INFO,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )
}
